import { lazy } from 'react';

// User Profile Management - 9 components
// Profile pages are explored together by logged-in users

export const Profile = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../pages/Profile'
));

export const ProfileEdit = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/Edit'
));

export const ProfileHealthAnalytics = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/HealthAnalytics'
));

export const ProfileAddress = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/Address'
));

export const ProfileChangePassword = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/ChangePassword'
));

export const ProfileAccount = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/Desktop/account'
));

export const ProfilePlanInfo = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/Desktop/PlanInfo/plan-info'
));

export const ProfileCreate = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../components/Profile/Create'
));

export const WalletHistory = lazy(() => import(
  /* webpackChunkName: "profile" */ '../../pages/WalletHistory'
));
